import PolicyDescription from './PolicyDescription';

export default PolicyDescription;
